export default "__VITE_ASSET__DSYXKTm___"